var _excluded = ["type"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createSelector } from 'reselect';
import moment from 'moment';
import { convertPurchaseToTransactionFormat } from 'researcher/digital-orders/reducer';
import { dateString } from 'researcher/helpers/date';
import featureEnabled from 'shared/helper/feature';
import * as c from './constants';
var FETCH_PADDLE_PRICES_REQUEST = 'FETCH_PADDLE_PRICES_REQUEST';
var FETCH_PADDLE_PRICES_SUCCESS = 'FETCH_PADDLE_PRICES_SUCCESS';
var FETCH_PADDLE_PRICES_FAILURE = 'FETCH_PADDLE_PRICES_FAILURE';
var initialState = {
  plan: {
    paddleSubscription: null
  },
  // /api/curie/load fills this in; selectors read it before it answers
  plans: {},
  paddlePricing: {
    prices: {},
    loading: false,
    country: null,
    currency: null
  },
  status: {
    paddlePending: false,
    paddlePendingCreatedOn: ''
  },
  plagiarismStatus: {
    fileIdentity: [],
    paddlePending: false,
    paddlePendingCreatedOn: ''
  },
  loaded: false,
  error: null,
  acknowledgedNotifications: {
    curieLaunchNotified: false
  },
  abstractWriter: {
    steps: {},
    session: '',
    currentStep: '',
    criteriaResponses: {},
    currentStage: '',
    responses: {},
    abstracts: [],
    searchBusy: false,
    title: '',
    createdAt: null
  },
  paddleInvoices: {
    payments: []
  }
};
export var getPlanExpirationStatusText = createSelector(function (_ref) {
  var plan = _ref.plan;
  return plan;
}, function (plan) {
  // Payment recovery grace period: payment failed on a paid or trial subscription.
  // Show "Renewal payment failed on {yesterday}" for all error states (paid past-due
  // AND trial past-due) to satisfy the AC for all user types.
  if (plan.status === 'error') {
    return 'curie.payment-recovery-renewal-failed';
  }
  if (plan.grantedFrom.grantingMechanism === 'paddle' && plan.paymentStatus === 'trialing' && plan.status !== 'cancelled') {
    return 'Payment set to start on %(monthName)s %(day)s, %(year)s';
  }
  if (plan.grantedFrom.grantingMechanism === 'paddle' && plan.status === 'active') {
    return 'Set to auto-renew on %(monthName)s %(day)s, %(year)s';
  }
  // Trial cancel (still within window) keeps the "Set to expire" messaging.
  if (plan.grantedFrom.grantingMechanism === 'paddle' && plan.status === 'cancelled' && plan.cancelState === 'trial') {
    return 'Set to expire on %(monthName)s %(day)s, %(year)s';
  }
  // Non-trial cancellation still within the paid period — user has access until endsAt.
  if (plan.status === 'cancelled' && plan.cancelState === 'nontrial' && plan.paymentStatus === 'active' && moment(plan.endsAt).utc().isAfter(moment().utc()) && !plan.pastDueStartedAt) {
    return 'Set to expire on %(monthName)s %(day)s, %(year)s';
  }
  if (plan.status === 'active') {
    return 'Set to expire on %(monthName)s %(day)s, %(year)s';
  }
  // Cancelled (non-trial) plans revoke all access and are presented as expired.
  if (plan.status === 'expired' || plan.status === 'cancelled') {
    return 'Expired on %(monthName)s %(day)s, %(year)s';
  }
  if (plan.status === 'error') {
    return 'Failed to renew on %(monthName)s %(day)s, %(year)s';
  }
  return '';
});

// ---------------------------------------------------------------------------
// Payment recovery grace period selector
// Covers ALL users in past_due state: monthly/annual paid subscribers AND
// trial users whose payment failed (trialGracePeriod === true).
// Both cases have premium.status === 'error'; the trialGracePeriod flag just
// controls access (trial-blocked = no access; paid = access retained), but
// the payment recovery banner should show for both.
// ---------------------------------------------------------------------------
export var getIsPastDue = function getIsPastDue(state) {
  var _state$curie;
  var premium = state === null || state === void 0 || (_state$curie = state.curie) === null || _state$curie === void 0 || (_state$curie = _state$curie.plans) === null || _state$curie === void 0 ? void 0 : _state$curie.premium;
  if (!premium) return false;
  return premium.status === 'error';
};
export var getPurchaseInformation = createSelector(function (_ref2) {
  var digitalEdit = _ref2.digitalEdit;
  return digitalEdit.availableDigitalPurchases;
}, function (_ref3) {
  var digitalEdit = _ref3.digitalEdit;
  return digitalEdit.digitalPurchases;
}, function (_, receiptCode) {
  return receiptCode;
}, function (_ref4) {
  var application = _ref4.application;
  return application.companyShortName;
}, convertPurchaseToTransactionFormat);
export var getPaddlePlanIdForCurrentPlan = createSelector(function (state) {
  var _state$curie$plans$pr;
  return (_state$curie$plans$pr = state.curie.plans.premium) === null || _state$curie$plans$pr === void 0 ? void 0 : _state$curie$plans$pr.paddlePlanId;
}, function (paddlePlanId) {
  return paddlePlanId;
});
export var getAvailablePlans = function getAvailablePlans(state) {
  return {
    premium: state.curie.plan.availablePlans.premium,
    trial: state.curie.plan.availablePlans.trial,
    snTrial30Days: state.curie.plan.availablePlans.trial_30_days
  };
};
export var getChinaAvailableNewPlans = function getChinaAvailableNewPlans(state) {
  var _state$curie$plan$ava, _state$curie$plan$ava2, _state$curie$plan$ava3;
  return {
    premiumWithTranslation: (_state$curie$plan$ava = state.curie.plan.availablePlans) === null || _state$curie$plan$ava === void 0 ? void 0 : _state$curie$plan$ava.premium,
    editingOnly: (_state$curie$plan$ava2 = state.curie.plan.availablePlans) === null || _state$curie$plan$ava2 === void 0 ? void 0 : _state$curie$plan$ava2.premium_editing,
    plagiarism: (_state$curie$plan$ava3 = state.curie.plan.availablePlans) === null || _state$curie$plan$ava3 === void 0 ? void 0 : _state$curie$plan$ava3.plagiarism_report
  };
};
export var getPaddleInvoice = createSelector(function (state) {
  var _state$curie2;
  return (state === null || state === void 0 || (_state$curie2 = state.curie) === null || _state$curie2 === void 0 || (_state$curie2 = _state$curie2.paddleInvoices) === null || _state$curie2 === void 0 ? void 0 : _state$curie2.payments) || [];
}, function (_, props) {
  var _props$match;
  return (_props$match = props.match) === null || _props$match === void 0 || (_props$match = _props$match.params) === null || _props$match === void 0 ? void 0 : _props$match.receiptCode;
}, function (paddlePayments, receiptCode) {
  if (!receiptCode) {
    return {};
  }
  var payment = paddlePayments.find(function (payment) {
    return payment.receiptCode === receiptCode;
  });
  return payment ? {
    invoiceNumber: payment.receiptCode
  } : {};
});
export var getPaddlePayment = createSelector(function (state) {
  var _state$curie3;
  return (state === null || state === void 0 || (_state$curie3 = state.curie) === null || _state$curie3 === void 0 || (_state$curie3 = _state$curie3.paddleInvoices) === null || _state$curie3 === void 0 ? void 0 : _state$curie3.payments) || [];
}, function (_, props) {
  var _props$match2;
  return (_props$match2 = props.match) === null || _props$match2 === void 0 || (_props$match2 = _props$match2.params) === null || _props$match2 === void 0 ? void 0 : _props$match2.receiptCode;
}, function (paddlePayments, receiptCode) {
  if (!paddlePayments.length || !receiptCode) return null;
  var targetPayment = paddlePayments.find(function (payment) {
    return payment.receiptCode === receiptCode;
  });
  if (!targetPayment) return null;
  return {
    paymentId: targetPayment.paymentId,
    amount: targetPayment.paidAmount.amount
  };
});

/**
 * True when the account signed up from a device that recently started a trial on another
 * account. The backend already treats it as alreadyTriedUser; this drives the CTAs that
 * would otherwise still offer a trial.
 */
export var getTrialFingerprintFlagged = function getTrialFingerprintFlagged(state) {
  var _state$curie4;
  return ((_state$curie4 = state.curie) === null || _state$curie4 === void 0 ? void 0 : _state$curie4.trialFingerprintFlagged) === true;
};

/**
 * The plans the pricing page sells, grouped by card.
 *
 * Two things move the Premium and Premium-with-Translation cards onto the no-trial SKUs:
 * a user who has already used a trial, and rubriq_cardless_free_trial, which retires the
 * card-required trial altogether in favour of the cardless one (started from its own SKU,
 * see getCardlessTrialPlan). The trial SKUs are kept as a fallback so this does not
 * depend on the backend deploying first.
 */
export var getAvailableNewPlans = function getAvailableNewPlans(state) {
  var _state$curie5, _availablePlans$trial, _availablePlans$plagi;
  var availablePlans = state.curie.plan.availablePlans;
  var useNoTrialPlans = featureEnabled('rubriq_cardless_free_trial') || ((_state$curie5 = state.curie) === null || _state$curie5 === void 0 ? void 0 : _state$curie5.alreadyTriedUser) === true;
  var planGroup = function planGroup(noTrialKey, trialKey) {
    var _ref5, _ref6;
    return (_ref5 = (_ref6 = useNoTrialPlans ? availablePlans === null || availablePlans === void 0 ? void 0 : availablePlans[noTrialKey] : null) !== null && _ref6 !== void 0 ? _ref6 : availablePlans === null || availablePlans === void 0 ? void 0 : availablePlans[trialKey]) !== null && _ref5 !== void 0 ? _ref5 : [];
  };
  return {
    premiumWithTranslation: planGroup('premium_including_translation_no_trial', 'premium_including_translation'),
    editing: planGroup('premium_editing_only_no_trial', 'premium_editing_only'),
    snTrial30Days: (_availablePlans$trial = availablePlans === null || availablePlans === void 0 ? void 0 : availablePlans.trial_30_days) !== null && _availablePlans$trial !== void 0 ? _availablePlans$trial : [],
    plagiarism: (_availablePlans$plagi = availablePlans === null || availablePlans === void 0 ? void 0 : availablePlans.plagiarism_report) !== null && _availablePlans$plagi !== void 0 ? _availablePlans$plagi : []
  };
};
var findByInterval = function findByInterval(plans, billingInterval) {
  var _plans$find;
  return (_plans$find = plans.find(function (plan) {
    return plan.billingInterval === billingInterval;
  })) !== null && _plans$find !== void 0 ? _plans$find : null;
};

/**
 * The plan that starts a cardless trial — its own monthly SKU, which is never shown as a
 * card of its own. Null when the flag is off or the SKU is not configured for this
 * environment, in which case callers must withhold the trial CTA rather than fall back to
 * a card-required price.
 */
export var getCardlessTrialPlan = function getCardlessTrialPlan(state) {
  var _state$curie$plan$ava4, _state$curie$plan$ava5, _ref7, _findByInterval;
  if (!featureEnabled('rubriq_cardless_free_trial')) return null;
  var cardlessPlans = (_state$curie$plan$ava4 = (_state$curie$plan$ava5 = state.curie.plan.availablePlans) === null || _state$curie$plan$ava5 === void 0 ? void 0 : _state$curie$plan$ava5.premium_editing_only_cardless_trial) !== null && _state$curie$plan$ava4 !== void 0 ? _state$curie$plan$ava4 : [];
  return (_ref7 = (_findByInterval = findByInterval(cardlessPlans, c.PADDLE_PLAN_TYPES.MONTHLY)) !== null && _findByInterval !== void 0 ? _findByInterval : cardlessPlans[0]) !== null && _ref7 !== void 0 ? _ref7 : null;
};
export var getPaddlePrices = function getPaddlePrices(state) {
  var _state$curie6;
  return ((_state$curie6 = state.curie) === null || _state$curie6 === void 0 || (_state$curie6 = _state$curie6.paddlePricing) === null || _state$curie6 === void 0 ? void 0 : _state$curie6.prices) || {};
};
export var getCurrencyIsoCode = function getCurrencyIsoCode(state) {
  var _state$curie7;
  return ((_state$curie7 = state.curie) === null || _state$curie7 === void 0 || (_state$curie7 = _state$curie7.paddlePricing) === null || _state$curie7 === void 0 ? void 0 : _state$curie7.currency) || 'USD';
};
export var isPaddlePricesLoading = function isPaddlePricesLoading(state) {
  var _state$curie8;
  return ((_state$curie8 = state.curie) === null || _state$curie8 === void 0 || (_state$curie8 = _state$curie8.paddlePricing) === null || _state$curie8 === void 0 ? void 0 : _state$curie8.loading) || false;
};
export var getEditingErrors = createSelector(function (_ref8) {
  var curie = _ref8.curie;
  return curie;
}, function (_ref9) {
  var curie = _ref9.curie;
  return getEditingStatus({
    curie: curie
  });
}, function (_ref10) {
  var curie = _ref10.curie;
  return getTranslationStatus({
    curie: curie
  });
}, function (_ref11) {
  var curie = _ref11.curie;
  return getNumberOfEditingUsesRemaining({
    curie: curie
  });
}, function (curie, editingStatus, translationStatus, editingUsesRemaining) {
  var digitalEditLimitReached = curie.plan.digitalEditLimitReached;
  var hasExpiredTrial = editingStatus.hasExpiredTrial,
    hasTrial = editingStatus.hasTrial,
    hasPremium = editingStatus.hasPremium,
    hasPreferredGroup = editingStatus.hasPreferredGroup,
    isPreferredGroupActive = editingStatus.isPreferredGroupActive,
    hasActivePremium = editingStatus.hasActivePremium,
    inTrialGracePeriodBlocked = editingStatus.inTrialGracePeriodBlocked;
  if (inTrialGracePeriodBlocked) {
    return {
      hasError: true,
      error: c.RUBRIQ_DIGITAL_EDITING_ERRORS.NO_PLAN
    };
  }

  // A premium plan that is no longer active (cancelled, paid past-due, expired)
  // loses editing access, even if the backend still reports remaining uses.
  // Preferred group / trial access is evaluated separately below.
  if (hasPremium && !hasActivePremium && !hasPreferredGroup && !hasTrial) {
    return {
      hasError: true,
      error: c.RUBRIQ_DIGITAL_EDITING_ERRORS.NO_PLAN
    };
  }
  if (hasPreferredGroup) {
    if (!hasActivePremium) {
      if (!isPreferredGroupActive) {
        return {
          hasError: true,
          error: c.RUBRIQ_DIGITAL_TRANSLATION_ERRORS.PREFERRED_GROUP_DISABLED_ERROR
        };
      }
    }
  }
  if (editingUsesRemaining > 0 || editingUsesRemaining === c.RUBRIQ_DIGITAL_EDITING_UNLIMITED_USES) {
    // if there are any available editing runs (no matter the source) the user should be good to go...

    if (digitalEditLimitReached) {
      // ...unless the hourly limit was reached
      return {
        hasError: true,
        error: c.RUBRIQ_DIGITAL_EDITING_ERRORS.HOURLY_LIMIT_EXCEEDED
      };
    }
    return {
      hasError: false
    };
  }

  // no available editing runs

  if (hasExpiredTrial) {
    // Free Trial has expired
    return {
      hasError: true,
      error: c.RUBRIQ_DIGITAL_EDITING_ERRORS.STARTER_PLAN_ENDED
    };
  }
  if (hasTrial || hasPreferredGroup) {
    // no runs available in the Preferred Group plan
    return {
      hasError: true,
      error: c.RUBRIQ_DIGITAL_EDITING_ERRORS.PREFERRED_GROUP_LIMIT_EXCEEDED
    };
  }

  // no plan
  return {
    hasError: true,
    error: c.RUBRIQ_DIGITAL_EDITING_ERRORS.NO_PLAN
  };
});
export var getTranslationsRenewalDate = createSelector(function (_ref12) {
  var curie = _ref12.curie;
  return getTranslationStatus({
    curie: curie
  });
}, function (_, t) {
  return t;
}, function (translationStatus, t) {
  var premiumTranslationsRenewalDate = translationStatus.premiumTranslationsRenewalDate;
  if (!premiumTranslationsRenewalDate) {
    return null;
  }
  return dateString(t, moment(premiumTranslationsRenewalDate), '%(monthName)s %(day)s, %(year)s at %(time)s');
});
export var getTranslationErrors = createSelector(function (_ref13) {
  var curie = _ref13.curie;
  return getTranslationStatus({
    curie: curie
  });
}, function (_ref14) {
  var curie = _ref14.curie;
  return getNumberOfTranslationUsesRemaining({
    curie: curie
  });
}, function (_, t) {
  return t;
}, function (translationStatus, translationUsesRemaining, t) {
  var hasTrial = translationStatus.hasTrial,
    hasPremium = translationStatus.hasPremium,
    hasActivePremium = translationStatus.hasActivePremium,
    premiumTranslationsRenewalDate = translationStatus.premiumTranslationsRenewalDate,
    hasPreferredGroup = translationStatus.hasPreferredGroup,
    hasPremiumTrial = translationStatus.hasPremiumTrial,
    isCardlessTrial = translationStatus.isCardlessTrial,
    editingOnlyPlan = translationStatus.editingOnlyPlan,
    cancelledDuringTrial = translationStatus.cancelledDuringTrial,
    planExpirationDate = translationStatus.planExpirationDate,
    hasPremiumTranslations = translationStatus.hasPremiumTranslations,
    currentPlanName = translationStatus.currentPlanName,
    hasPreferredGroupTranslations = translationStatus.hasPreferredGroupTranslations,
    isPreferredGroupActive = translationStatus.isPreferredGroupActive,
    premiumTranslationsRemaining = translationStatus.premiumTranslationsRemaining,
    inTrialGracePeriodBlocked = translationStatus.inTrialGracePeriodBlocked;
  var deepSeekEnabled = featureEnabled('rubriq_china_deep_seek');
  if (inTrialGracePeriodBlocked) {
    return {
      hasError: true,
      error: c.RUBRIQ_DIGITAL_TRANSLATION_ERRORS.NO_PLAN
    };
  }
  if (cancelledDuringTrial && currentPlanName === 'premium_including_translation') {
    return {
      hasError: true,
      error: c.RUBRIQ_DIGITAL_TRANSLATION_ERRORS.CANCELLED_PLAN_NO_TRANSLATIONS({
        renewalDate: dateString(t, moment(planExpirationDate), '%(monthName)s %(day)s, %(year)s at %(time)s')
      })
    };
  }
  if (isCardlessTrial) {
    return {
      hasError: true,
      error: c.RUBRIQ_DIGITAL_TRANSLATION_ERRORS.CARDLESS_TRIAL_NO_TRANSLATIONS
    };
  }
  if (editingOnlyPlan) {
    return {
      hasError: true,
      error: c.RUBRIQ_DIGITAL_TRANSLATION_ERRORS.EDITING_ONLY_PLAN_NO_TRANSLATIONS
    };
  }
  if (hasPremiumTrial) {
    return {
      hasError: true,
      error: c.RUBRIQ_DIGITAL_TRANSLATION_ERRORS.PAID_TRANSLATIONS_AVAILABILITY_DATE({
        renewalDate: dateString(t, moment(premiumTranslationsRenewalDate), '%(monthName)s %(day)s, %(year)s at %(time)s')
      })
    };
  }
  if (hasPreferredGroup) {
    if (!hasActivePremium) {
      if (!isPreferredGroupActive) {
        return {
          hasError: true,
          error: c.RUBRIQ_DIGITAL_TRANSLATION_ERRORS.PREFERRED_GROUP_DISABLED_ERROR
        };
      }
    }
  }
  if (hasPremium && hasPreferredGroup) {
    if (!isPreferredGroupActive && !premiumTranslationsRemaining > 0) {
      return {
        hasError: true,
        error: c.RUBRIQ_DIGITAL_TRANSLATION_ERRORS.PREFERRED_GROUP_DISABLED_ERROR
      };
    }
  }
  if ((translationUsesRemaining > 0 || deepSeekEnabled && (hasPremiumTranslations || hasPreferredGroupTranslations)) && (hasActivePremium || hasPreferredGroup)) {
    // if there are any available translation runs (no matter the source) the user is good to go!
    return {
      hasError: false
    };
  }

  // no available translation runs
  if (hasPremium && !hasActivePremium) {
    return {
      hasError: true,
      error: c.RUBRIQ_DIGITAL_TRANSLATION_ERRORS.NO_PLAN
    };
  }
  if (hasTrial && !hasPremium) {
    // Free Trials don't include translations
    return {
      hasError: true,
      error: c.RUBRIQ_DIGITAL_TRANSLATION_ERRORS.STARTER_PLAN_NO_TRANSLATIONS
    };
  }
  if (hasPremium && hasPreferredGroup) {
    // no runs available in the Premium or Preferred Group plans
    return {
      hasError: true,
      error: c.RUBRIQ_DIGITAL_TRANSLATION_ERRORS.NUMBER_OF_PREMIUM_AND_PREFERRED_GROUP_TRANSLATIONS_EXCEEDED({
        renewalDate: dateString(t, moment(premiumTranslationsRenewalDate), '%(monthName)s %(day)s, %(year)s at %(time)s')
      })
    };
  }
  if (hasPremium) {
    // no runs available in the Premium plan
    return {
      hasError: true,
      error: c.RUBRIQ_DIGITAL_TRANSLATION_ERRORS.NUMBER_OF_PREMIUM_TRANSLATIONS_EXCEEDED({
        renewalDate: dateString(t, moment(premiumTranslationsRenewalDate), '%(monthName)s %(day)s, %(year)s at %(time)s')
      })
    };
  }
  if (hasPreferredGroup) {
    // no runs available in the Preferred Group plan
    return {
      hasError: true,
      error: c.RUBRIQ_DIGITAL_TRANSLATION_ERRORS.NUMBER_OF_PREFERRED_GROUP_TRANSLATIONS_EXCEEDED
    };
  }
  // no plan
  return {
    hasError: true,
    error: c.RUBRIQ_DIGITAL_TRANSLATION_ERRORS.NO_PLAN
  };
});
export var getNumberOfEditingUsesRemaining = createSelector(function (_ref15) {
  var curie = _ref15.curie;
  return curie;
}, function (curie) {
  var _curie$access;
  return (_curie$access = curie.access) === null || _curie$access === void 0 || (_curie$access = _curie$access.features) === null || _curie$access === void 0 || (_curie$access = _curie$access.editing) === null || _curie$access === void 0 ? void 0 : _curie$access.usesRemaining;
});
export var getNumberOfTranslationUsesRemaining = createSelector(function (_ref16) {
  var curie = _ref16.curie;
  return curie;
}, function (curie) {
  var _curie$access2;
  return (_curie$access2 = curie.access) === null || _curie$access2 === void 0 || (_curie$access2 = _curie$access2.features) === null || _curie$access2 === void 0 || (_curie$access2 = _curie$access2.translation) === null || _curie$access2 === void 0 ? void 0 : _curie$access2.usesRemaining;
});
export var getEditingStatus = createSelector(function (_ref17) {
  var curie = _ref17.curie;
  return curie;
}, function (curie) {
  var _curie$plans, _freeTrial$endsAt;
  var _ref18 = (_curie$plans = curie.plans) !== null && _curie$plans !== void 0 ? _curie$plans : {},
    freeTrial = _ref18.free_trial,
    premium = _ref18.premium,
    preferredGroup = _ref18.preferred_group;

  // Free Trial (China: curie.plans.free_trial)
  var hasFreeTrial = !!freeTrial;
  var hasFreeActiveTrial = hasFreeTrial && freeTrial.status === 'active';
  var hasFreeExpiredTrial = hasFreeTrial && freeTrial.status === 'expired';

  // Paddle Trial (ROW: curie.plans.premium with paymentStatus === 'trialing')
  var isPaddleTrial = !!premium && premium.paymentStatus === 'trialing';
  var isPaddleTrialActive = isPaddleTrial && premium.status !== 'expired' && moment(premium.endsAt).isAfter(moment());
  var isPaddleTrialExpired = isPaddleTrial && (premium.status === 'expired' || !moment(premium.endsAt).isAfter(moment()));

  // Combined — at most one source is populated for any given user.
  var hasTrial = hasFreeTrial || isPaddleTrial;
  var hasActiveTrial = hasFreeActiveTrial || isPaddleTrialActive;
  var hasExpiredTrial = hasFreeExpiredTrial || isPaddleTrialExpired;
  var trialExpirationDate = (_freeTrial$endsAt = freeTrial === null || freeTrial === void 0 ? void 0 : freeTrial.endsAt) !== null && _freeTrial$endsAt !== void 0 ? _freeTrial$endsAt : premium === null || premium === void 0 ? void 0 : premium.endsAt;
  var trialDaysRemaining;
  if (hasTrial) {
    trialDaysRemaining = hasExpiredTrial ? 0 : moment(trialExpirationDate).diff(moment(), 'days');
  }

  // Premium
  var hasPremium = !!premium;
  var inTrialGracePeriodBlocked = hasPremium && premium.trialGracePeriod === true;
  // A non-trial cancellation within the paid period retains access —
  // UNLESS pastDueStartedAt is set (payment failed before cancel — no access).
  var isCancelledNonTrialWithinPaidPeriod = hasPremium && premium.status === 'cancelled' && premium.cancelState === 'nontrial' && premium.paymentStatus === 'active' && moment(premium.endsAt).isAfter(moment()) && !premium.pastDueStartedAt;
  // A trial cancellation still within the trial window also retains access.
  var isCancelledTrialWithinTrialPeriod = hasPremium && premium.status === 'cancelled' && premium.cancelState === 'trial' && premium.paymentStatus === 'active' && moment(premium.endsAt).isAfter(moment());
  // Paid past-due: payment failed on a paid (non-trial) subscription.
  // The user retains access during the recovery window (trialGracePeriod === false).
  var isPaidPastDue = hasPremium && premium.status === 'error' && premium.trialGracePeriod === false;
  // Active, cancelled-within-window, and paid-past-due all retain access.
  // Trial grace period (trialGracePeriod=true) and truly expired plans revoke access.
  var hasActivePremium = hasPremium && !inTrialGracePeriodBlocked && (premium.status === 'active' || isCancelledNonTrialWithinPaidPeriod || isCancelledTrialWithinTrialPeriod || isPaidPastDue);
  var hasExpiredPremium = hasPremium && premium.status === 'expired';
  var premiumExpirationDate = premium === null || premium === void 0 ? void 0 : premium.endsAt;
  var isPremiumTrial = hasPremium && premium.paymentStatus === 'trialing';

  // Preferred Group
  var hasPreferredGroup = !!preferredGroup;
  var hasExpiredPreferredGroup = hasPreferredGroup && preferredGroup.status === 'expired';
  var preferredGroupExpirationDate = hasPreferredGroup && (preferredGroup === null || preferredGroup === void 0 ? void 0 : preferredGroup.endsAt);
  var isPreferredGroupActive = !!(hasPreferredGroup && preferredGroup !== null && preferredGroup !== void 0 && preferredGroup.preferredGroupRubriqStatus);
  return {
    noPlan: !hasTrial && !hasPremium && !hasPreferredGroup,
    hasTrial: hasTrial,
    hasActiveTrial: hasActiveTrial,
    hasExpiredTrial: hasExpiredTrial,
    trialExpirationDate: trialExpirationDate,
    trialDaysRemaining: trialDaysRemaining,
    hasPremium: hasPremium,
    hasActivePremium: hasActivePremium,
    hasExpiredPremium: hasExpiredPremium,
    premiumExpirationDate: premiumExpirationDate,
    isPremiumTrial: isPremiumTrial,
    hasPreferredGroup: hasPreferredGroup,
    hasExpiredPreferredGroup: hasExpiredPreferredGroup,
    preferredGroupExpirationDate: preferredGroupExpirationDate,
    isPreferredGroupActive: isPreferredGroupActive,
    inTrialGracePeriodBlocked: inTrialGracePeriodBlocked
  };
});
export var getAbstractStatus = createSelector(function (_ref19) {
  var curie = _ref19.curie;
  return curie;
}, function (curie) {
  var _curie$plans2;
  var _ref20 = (_curie$plans2 = curie.plans) !== null && _curie$plans2 !== void 0 ? _curie$plans2 : {},
    freeTrial = _ref20.free_trial,
    premium = _ref20.premium,
    preferredGroup = _ref20.preferred_group;

  // Free Trial
  var hasTrial = !!freeTrial;
  var hasExpiredTrial = hasTrial && freeTrial.status === 'expired';
  var trialExpirationDate = freeTrial === null || freeTrial === void 0 ? void 0 : freeTrial.endsAt;
  var trialDaysRemaining;
  if (hasTrial) {
    trialDaysRemaining = hasExpiredTrial ? 0 : moment(trialExpirationDate).diff(moment(), 'days');
  }

  // Premium (Abstract-specific)
  var hasPremium = !!premium;
  var inTrialGracePeriodBlocked = hasPremium && premium.trialGracePeriod === true;
  // A non-trial cancellation within the paid period retains access —
  // UNLESS pastDueStartedAt is set (payment failed before cancel — no access).
  var isCancelledNonTrialWithinPaidPeriod = hasPremium && premium.status === 'cancelled' && premium.cancelState === 'nontrial' && premium.paymentStatus === 'active' && moment(premium.endsAt).isAfter(moment()) && !premium.pastDueStartedAt;
  // Paid past-due: payment failed on a paid (non-trial) subscription.
  // The user retains access during the recovery window (trialGracePeriod === false).
  var isPaidPastDue = hasPremium && premium.status === 'error' && premium.trialGracePeriod === false;
  // Abstract is a paid-only feature — trial and cancelled-trial users do not have access.
  // Active paid, cancelled-nontrial-within-period, and paid-past-due all retain access.
  // Trial grace period (trialGracePeriod=true) revokes access.
  // paymentStatus === 'trialing' means the subscription is in its trial window and no payment has
  // been collected yet — these users must be blocked even though premium.status === 'active'.
  var isTrialing = hasPremium && premium.paymentStatus === 'trialing';
  var hasActivePremium = hasPremium && !inTrialGracePeriodBlocked && !isTrialing && (premium.status === 'active' || isCancelledNonTrialWithinPaidPeriod || isPaidPastDue);
  var hasExpiredPremium = hasPremium && premium.status === 'expired';
  var premiumExpirationDate = premium === null || premium === void 0 ? void 0 : premium.endsAt;

  // Preferred Group
  var hasPreferredGroup = !!preferredGroup;
  var hasExpiredPreferredGroup = hasPreferredGroup && preferredGroup.status === 'expired';
  var preferredGroupExpirationDate = preferredGroup === null || preferredGroup === void 0 ? void 0 : preferredGroup.endsAt;
  var isPreferredGroupActive = !!(hasPreferredGroup && preferredGroup !== null && preferredGroup !== void 0 && preferredGroup.preferredGroupRubriqStatus);
  var hasPreferredGroupAbstracts = hasPreferredGroup && !!preferredGroup.access.features.abstract;
  var groupAbstractsProvisioned = hasPreferredGroupAbstracts ? preferredGroup.access.features.abstract.usesProvisioned : 0;
  var groupAbstractsRemaining = hasPreferredGroupAbstracts ? preferredGroup.access.features.abstract.usesRemaining : 0;
  return {
    noPlan: !hasPremium && !hasPreferredGroup,
    hasTrial: hasTrial,
    hasExpiredTrial: hasExpiredTrial,
    trialExpirationDate: trialExpirationDate,
    trialDaysRemaining: trialDaysRemaining,
    hasPremium: hasPremium,
    hasActivePremium: hasActivePremium,
    isTrialing: isTrialing,
    hasExpiredPremium: hasExpiredPremium,
    premiumExpirationDate: premiumExpirationDate,
    hasPreferredGroup: hasPreferredGroup,
    hasExpiredPreferredGroup: hasExpiredPreferredGroup,
    preferredGroupExpirationDate: preferredGroupExpirationDate,
    isPreferredGroupActive: isPreferredGroupActive,
    hasPreferredGroupAbstracts: hasPreferredGroupAbstracts,
    groupAbstractsProvisioned: groupAbstractsProvisioned,
    groupAbstractsRemaining: groupAbstractsRemaining
  };
});
export var getNumberOfAbstractUsesRemaining = createSelector(function (_ref21) {
  var curie = _ref21.curie;
  return curie;
}, function (curie) {
  var _curie$access3;
  return (_curie$access3 = curie.access) === null || _curie$access3 === void 0 || (_curie$access3 = _curie$access3.features) === null || _curie$access3 === void 0 || (_curie$access3 = _curie$access3.abstract) === null || _curie$access3 === void 0 ? void 0 : _curie$access3.usesRemaining;
});
export var getAbstractErrors = createSelector(function (_ref22) {
  var curie = _ref22.curie;
  return curie;
}, function (_ref23) {
  var curie = _ref23.curie;
  return getAbstractStatus({
    curie: curie
  });
}, function (_ref24) {
  var curie = _ref24.curie;
  return getNumberOfAbstractUsesRemaining({
    curie: curie
  });
}, function (curie, abstractStatus, abstractUsesRemaining) {
  var digitalAbstractLimitReached = curie.plan.digitalAbstractLimitReached;
  var hasPremium = abstractStatus.hasPremium,
    hasActivePremium = abstractStatus.hasActivePremium,
    hasPreferredGroup = abstractStatus.hasPreferredGroup,
    isPreferredGroupActive = abstractStatus.isPreferredGroupActive,
    inTrialGracePeriodBlocked = abstractStatus.inTrialGracePeriodBlocked,
    isTrialing = abstractStatus.isTrialing;
  if (inTrialGracePeriodBlocked) {
    return {
      hasError: true,
      error: c.RUBRIQ_DIGITAL_ABSTRACT_ERRORS.NO_PLAN
    };
  }
  if (isTrialing) {
    return {
      hasError: true,
      error: c.RUBRIQ_DIGITAL_ABSTRACT_ERRORS.NO_PLAN
    };
  }
  if (hasPreferredGroup && !hasActivePremium) {
    if (!isPreferredGroupActive) {
      return {
        hasError: true,
        error: c.RUBRIQ_DIGITAL_ABSTRACT_ERRORS.PREFERRED_GROUP_DISABLED_ERROR
      };
    }
  }
  if (abstractUsesRemaining > 0) {
    if (digitalAbstractLimitReached) {
      return {
        hasError: true,
        error: c.RUBRIQ_DIGITAL_ABSTRACT_ERRORS.HOURLY_LIMIT_EXCEEDED
      };
    }
    return {
      hasError: false
    };
  }

  // no available abstract runs
  if (hasPreferredGroup) {
    return {
      hasError: true,
      error: c.RUBRIQ_DIGITAL_ABSTRACT_ERRORS.PREFERRED_GROUP_LIMIT_EXCEEDED
    };
  }
  if (hasPremium && !hasActivePremium) {
    return {
      hasError: true,
      error: c.RUBRIQ_DIGITAL_ABSTRACT_ERRORS.NO_PLAN
    };
  }
  if (hasPremium) {
    return {
      hasError: true,
      error: c.RUBRIQ_DIGITAL_ABSTRACT_ERRORS.NUMBER_OF_EDITS_EXCEEDED
    };
  }
  return {
    hasError: true,
    error: c.RUBRIQ_DIGITAL_ABSTRACT_ERRORS.NO_PLAN
  };
});
export var getTranslationStatus = createSelector(function (_ref25) {
  var curie = _ref25.curie;
  return curie;
}, function (_ref26) {
  var curie = _ref26.curie;
  return getNumberOfTranslationUsesRemaining({
    curie: curie
  });
}, function (curie, translationUsesRemaining) {
  var _curie$plans3, _premium$access$featu, _curie$plan;
  var _ref27 = (_curie$plans3 = curie.plans) !== null && _curie$plans3 !== void 0 ? _curie$plans3 : {},
    freeTrial = _ref27.free_trial,
    premium = _ref27.premium,
    preferredGroup = _ref27.preferred_group;

  // Free Trial
  var hasTrial = !!freeTrial;
  var hasActiveTrial = hasTrial && freeTrial.status === 'active';
  var currentPlanName = (premium === null || premium === void 0 ? void 0 : premium.planName) || null;
  var editingOnlyPlan = (premium === null || premium === void 0 ? void 0 : premium.planName) === 'premium_editing_only' || (premium === null || premium === void 0 ? void 0 : premium.planName) === 'premium_editing_only_admin' || (premium === null || premium === void 0 ? void 0 : premium.planName) === 'premium_editing_only_no_trial' || (premium === null || premium === void 0 ? void 0 : premium.planName) === 'premium_editing';
  var premiumWithTranslationsPlan = (premium === null || premium === void 0 ? void 0 : premium.planName) === 'premium_including_translation' || (premium === null || premium === void 0 ? void 0 : premium.planName) === 'premium_including_translation_no_trial' || (premium === null || premium === void 0 ? void 0 : premium.planName) === 'premium';
  var hasOtherPremiumPlan = premiumWithTranslationsPlan || editingOnlyPlan;
  // Premium
  var hasPremium = !!premium;
  var inTrialGracePeriodBlocked = hasPremium && premium.trialGracePeriod === true;
  // A non-trial cancellation within the paid period retains access —
  // UNLESS pastDueStartedAt is set (payment failed before cancel — no access).
  var isCancelledNonTrialWithinPaidPeriod = hasPremium && premium.status === 'cancelled' && premium.cancelState === 'nontrial' && premium.paymentStatus === 'active' && moment(premium.endsAt).isAfter(moment()) && !premium.pastDueStartedAt;
  // A trial cancellation still within the trial window also retains access.
  var isCancelledTrialWithinTrialPeriod = hasPremium && premium.status === 'cancelled' && premium.cancelState === 'trial' && premium.paymentStatus === 'active' && moment(premium.endsAt).isAfter(moment());
  // Paid past-due: payment failed on a paid (non-trial) subscription.
  // The user retains access during the recovery window (trialGracePeriod === false).
  var isPaidPastDue = hasPremium && premium.status === 'error' && premium.trialGracePeriod === false;
  // Only an active plan (or a cancelled-but-still-paid/trial plan, or paid past-due) retains access.
  // Trial grace period (trialGracePeriod=true) and truly expired plans revoke access.
  var hasActivePremium = hasPremium && (premium.status === 'active' || isCancelledNonTrialWithinPaidPeriod || isCancelledTrialWithinTrialPeriod || isPaidPastDue) && !inTrialGracePeriodBlocked;
  var hasPremiumTranslations = hasPremium && !!premium.access.features.translation;
  var premiumTranslationsRemaining = hasPremiumTranslations ? premium.access.features.translation.usesRemaining : 0;
  var premiumTranslationsRenewalDate = premium === null || premium === void 0 || (_premium$access$featu = premium.access.features.translation) === null || _premium$access$featu === void 0 ? void 0 : _premium$access$featu.nextRecurrence;
  var hasPremiumTrial = (premium === null || premium === void 0 ? void 0 : premium.paymentStatus) === 'trialing';
  var isCardlessTrial = featureEnabled('rubriq_cardless_free_trial') && ((_curie$plan = curie.plan) === null || _curie$plan === void 0 || (_curie$plan = _curie$plan.paddleSubscription) === null || _curie$plan === void 0 ? void 0 : _curie$plan.isCardlessTrial) === true && hasPremiumTrial;

  // Preferred Group
  var hasPreferredGroup = !!preferredGroup;
  var isPreferredGroupActive = !!(hasPreferredGroup && preferredGroup !== null && preferredGroup !== void 0 && preferredGroup.preferredGroupRubriqStatus);
  var hasPreferredGroupTranslations = hasPreferredGroup && !!preferredGroup.access.features.translation;
  var groupTranslationsProvisioned = hasPreferredGroupTranslations ? preferredGroup.access.features.translation.usesProvisioned : 0;
  var groupTranslationsRemaining = hasPreferredGroupTranslations ? preferredGroup.access.features.translation.usesRemaining : 0;
  var cancelledDuringTrial = (premium === null || premium === void 0 ? void 0 : premium.cancelState) === 'trial';
  var planExpirationDate = premium === null || premium === void 0 ? void 0 : premium.endsAt;

  // Unlimited Translations
  var deepSeekEnabled = featureEnabled('rubriq_china_deep_seek');
  var translationsRemaining = premiumTranslationsRemaining;
  return {
    hasTrial: hasTrial,
    hasActiveTrial: hasActiveTrial,
    hasPremiumTrial: hasPremiumTrial,
    isCardlessTrial: isCardlessTrial,
    hasPremium: hasPremium,
    hasActivePremium: hasActivePremium,
    hasPremiumTranslations: hasPremiumTranslations,
    premiumTranslationsRemaining: premiumTranslationsRemaining,
    premiumTranslationsRenewalDate: premiumTranslationsRenewalDate,
    hasPreferredGroup: hasPreferredGroup,
    hasPreferredGroupTranslations: hasPreferredGroupTranslations,
    groupTranslationsProvisioned: groupTranslationsProvisioned,
    groupTranslationsRemaining: groupTranslationsRemaining,
    translationUsesRemaining: translationUsesRemaining,
    editingOnlyPlan: editingOnlyPlan,
    cancelledDuringTrial: cancelledDuringTrial,
    premiumWithTranslationsPlan: premiumWithTranslationsPlan,
    planExpirationDate: planExpirationDate,
    deepSeekEnabled: deepSeekEnabled,
    translationsRemaining: translationsRemaining,
    currentPlanName: currentPlanName,
    isPreferredGroupActive: isPreferredGroupActive,
    hasOtherPremiumPlan: hasOtherPremiumPlan,
    inTrialGracePeriodBlocked: inTrialGracePeriodBlocked
  };
});
export var getMaxResponseTier = createSelector(function (_ref28) {
  var curie = _ref28.curie;
  return curie;
}, function (curie) {
  var _curie$abstractWriter = curie.abstractWriter,
    steps = _curie$abstractWriter.steps,
    responses = _curie$abstractWriter.criteriaResponses;
  return Object.keys(responses).reduce(function (previousValue, currentValue) {
    if (currentValue === 'text-limit') {
      return previousValue;
    }
    var tier = steps[currentValue].tier;
    if (tier > previousValue) {
      return tier;
    }
    return previousValue;
  }, 0);
});
export var getMaxStepTiers = createSelector(function (_ref29) {
  var curie = _ref29.curie;
  return curie;
}, function (curie) {
  var steps = curie.abstractWriter.steps;
  return Object.keys(steps).reduce(function (previousValue, currentValue) {
    var tier = steps[currentValue].tier;
    if (tier > previousValue) {
      return tier;
    }
    return previousValue;
  }, 0);
});
export var getPreviousStep = createSelector(function (_ref30) {
  var curie = _ref30.curie;
  return curie;
}, function (_ref31) {
  var curie = _ref31.curie;
  return getMaxResponseTier({
    curie: curie
  });
}, function (_, currentStep) {
  return currentStep;
}, function (curie, maxResponseTier, currentStep) {
  var _curie$abstractWriter2 = curie.abstractWriter,
    steps = _curie$abstractWriter2.steps,
    responses = _curie$abstractWriter2.criteriaResponses;
  if (currentStep === 'onboarding') {
    return null;
  }
  if (currentStep === 'confirmation') {
    return 'text-limit';
  }
  if (currentStep === 'text-limit') {
    return Object.keys(responses).find(function (response) {
      if (response === 'text-limit') {
        return false;
      }
      var tier = steps[response].tier;

      // since we are at the "text-limit" step, the previous step is the deeper one in the decision tree for which we have a response
      return tier === maxResponseTier;
    });
  }
  if (steps[currentStep].tier === 1) {
    return 'onboarding';
  }
  return Object.keys(responses).reduce(function (previousValue, currentValue) {
    if (currentValue === 'text-limit') {
      // since we aren't at the confirmation step, the "text-limit" step cannot be the previous one
      return previousValue;
    }
    var currentValueTier = steps[currentValue].tier;
    if (currentValueTier >= steps[currentStep].tier) {
      // step is in a tier (ie. the level/layer in the decision tree) below the current one (or is the current one)
      // so it cannot be the previous step
      return previousValue;
    }
    if (!previousValue) {
      // keep step as our best candidate for the previous step so far (since we have none yet)
      return currentValue;
    }
    var previousValueTier = steps[previousValue].tier;
    if (currentValueTier < previousValueTier) {
      // step is in a tier above the tier of our current best candidate for the previous step so let's get rid of it
      // (since it's further away from the current step)
      return previousValue;
    }

    // keep step as our new best candidate for the previous step so far (since it's closer to the current step)
    return currentValue;
  }, '');
});
export var getProgressPercentage = createSelector(function (_ref32) {
  var curie = _ref32.curie;
  return curie;
}, function (_ref33) {
  var curie = _ref33.curie;
  return getMaxStepTiers({
    curie: curie
  });
}, function (_, currentStep) {
  return currentStep;
}, function (curie, maxStepTiers, currentStep) {
  var steps = curie.abstractWriter.steps;
  if (currentStep === 'onboarding') {
    return 0;
  }
  if (currentStep === 'confirmation') {
    return 100;
  }
  var totalTiers = maxStepTiers + 3; // adding tiers for "onboarding", "text-limit" and "confirmation" steps

  if (currentStep === 'text-limit') {
    var textLimitStepTier = maxStepTiers + 1;
    return Math.floor(textLimitStepTier / totalTiers * 100);
  }
  return Math.floor(steps[currentStep].tier / totalTiers * 100);
});
export var getNextStep = createSelector(function (_ref34) {
  var curie = _ref34.curie;
  return curie;
}, function (_, currentStep, responseData) {
  return {
    currentStep: currentStep,
    responseData: responseData
  };
}, function (curie, _ref35) {
  var currentStep = _ref35.currentStep,
    responseData = _ref35.responseData;
  var steps = curie.abstractWriter.steps;
  if (currentStep === 'onboarding') {
    return 'destination';
  }
  if (currentStep === 'text-limit') {
    return 'confirmation';
  }
  var response = responseData.response;
  var possibleResponses = steps[currentStep].possibleResponses;
  return possibleResponses.find(function (possibleResponse) {
    return possibleResponse.value === response;
  }).nextStep;
});
export var getUpdatedResponses = createSelector(function (_ref36) {
  var curie = _ref36.curie;
  return curie;
}, function (_, currentStep, responseData) {
  return {
    currentStep: currentStep,
    responseData: responseData
  };
}, function (_ref37, currentStep, responseData) {
  var curie = _ref37.curie;
  return getNextStep({
    curie: curie
  }, currentStep, responseData);
}, function (curie, _ref38, nextStep) {
  var currentStep = _ref38.currentStep,
    responseData = _ref38.responseData;
  var _curie$abstractWriter3 = curie.abstractWriter,
    steps = _curie$abstractWriter3.steps,
    responses = _curie$abstractWriter3.criteriaResponses;
  if (currentStep === 'onboarding') {
    return responses;
  }
  if (currentStep === 'text-limit') {
    var maxLength = responseData.maxLength,
      value = responseData.units.value;
    return _objectSpread(_objectSpread({}, responses), {}, {
      'text-limit': {
        maxLength: maxLength,
        useCharacters: value === 'characters'
      }
    });
  }
  var response = responseData.response;
  var possibleResponses = steps[currentStep].possibleResponses;
  var resetResponses = {};

  // let's check if the user already provided a response to the same step before
  if (responses[currentStep]) {
    // let's check if the next step will be different now with the new response
    var oldNextStep = possibleResponses.find(function (possibleResponse) {
      return possibleResponse.value === responses[currentStep];
    }).nextStep;
    if (nextStep !== oldNextStep) {
      // reset responses for steps after the current one (if any) since the path in the decision tree will be different from now on
      resetResponses = Object.keys(responses).reduce(function (previousValue, currentValue) {
        if (currentValue === 'text-limit') {
          // there are no responses to provide beyond the "text-limit" step
          return previousValue;
        }
        var responseTier = steps[currentValue].tier;
        var stepTier = steps[currentStep].tier;
        if (responseTier > stepTier) {
          // response is for a step in a tier (ie. the level/layer in the decision tree) below the current one so let's get rid of it
          return previousValue;
        }
        var result = _objectSpread({}, previousValue);

        // keep response since it's for a previous step
        result[currentValue] = responses[currentValue];
        return result;
      }, {});
    } else {
      // new response leads to the same next step so no need to reset anything
      resetResponses = _objectSpread({}, responses);
    }
  } else {
    // it's the first response to this step so no need to reset anything
    resetResponses = _objectSpread({}, responses);
  }

  // set up responses provided so far
  var updatedResponses = _objectSpread({}, resetResponses);

  // add response to this step
  updatedResponses[currentStep] = response;
  return updatedResponses;
});
export var getSortedResponses = createSelector(function (_ref39) {
  var curie = _ref39.curie;
  return curie;
}, function (curie) {
  var _curie$abstractWriter4 = curie.abstractWriter,
    steps = _curie$abstractWriter4.steps,
    responses = _curie$abstractWriter4.criteriaResponses;
  return Object.keys(responses).map(function (key) {
    var label = key === 'text-limit' ? '' : steps[key].label;
    var tier = key === 'text-limit' ? null : steps[key].tier;
    return {
      step: key,
      label: label,
      tier: tier,
      response: responses[key]
    };
  }).sort(function (a, b) {
    if (a.step === 'text-limit') {
      return 1;
    }
    if (b.step === 'text-limit') {
      return -1;
    }
    return b.tier < a.tier ? 1 : -1;
  });
});
var getDocumentStatuses = function getDocumentStatuses(state) {
  var _state$curie9;
  return ((_state$curie9 = state.curie) === null || _state$curie9 === void 0 || (_state$curie9 = _state$curie9.plagiarismStatus) === null || _state$curie9 === void 0 ? void 0 : _state$curie9.documentStatuses) || {};
};
export var isDocumentPaymentPending = function isDocumentPaymentPending(state, fileIdentity) {
  var _docStatuses$fileIden;
  var docStatuses = getDocumentStatuses(state);
  return ((_docStatuses$fileIden = docStatuses[fileIdentity]) === null || _docStatuses$fileIden === void 0 ? void 0 : _docStatuses$fileIden.paddlePending) === true;
};
export var hasAnyPendingPayments = function hasAnyPendingPayments(state) {
  var docStatuses = getDocumentStatuses(state);
  return Object.values(docStatuses).some(function (doc) {
    return doc.paddlePending === true;
  });
};
export var getPendingPaymentDocuments = function getPendingPaymentDocuments(state) {
  var docStatuses = getDocumentStatuses(state);
  return Object.values(docStatuses).filter(function (doc) {
    return doc.paddlePending === true;
  });
};
var normalizeDocumentStatuses = function normalizeDocumentStatuses(status) {
  var fallbackFileIdentity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (Array.isArray(status)) {
    return status.reduce(function (acc, doc) {
      if (doc !== null && doc !== void 0 && doc.fileIdentity) {
        acc[doc.fileIdentity] = {
          paddlePending: doc.paddlePending || false,
          paddlePendingCreatedOn: doc.paddlePendingCreatedOn,
          fileIdentity: doc.fileIdentity
        };
      }
      return acc;
    }, {});
  }
  var fileIdentity = (status === null || status === void 0 ? void 0 : status.fileIdentity) || fallbackFileIdentity;
  if (fileIdentity) {
    return _defineProperty({}, fileIdentity, {
      paddlePending: (status === null || status === void 0 ? void 0 : status.paddlePending) || false,
      paddlePendingCreatedOn: status === null || status === void 0 ? void 0 : status.paddlePendingCreatedOn,
      fileIdentity: fileIdentity
    });
  }
  return {};
};
export var rubriqReducer = function rubriqReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
    props = _objectWithoutProperties(action, _excluded);
  switch (type) {
    case c.RUBRIQ_LOAD_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        loaded: false
      });
    case c.CURIE_DATA_UPDATED:
      return _objectSpread(_objectSpread(_objectSpread({}, state), action), {}, {
        loaded: false
      });
    case c.RUBRIQ_LOAD_COMPLETED:
      return _objectSpread(_objectSpread(_objectSpread({}, state), props), {}, {
        loaded: true
      });
    case c.RUBRIQ_SYNCED:
      return _objectSpread(_objectSpread({}, state), props);
    case c.DIGITAL_EDIT_LIMIT_REACHED_LOADED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          plan: _objectSpread(_objectSpread({}, state.plan), {}, {
            digitalEditLimitReached: props.digitalEditLimitReached
          })
        });
      }
    case c.DIGITAL_ABSTRACT_LIMIT_REACHED_LOADED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          plan: _objectSpread(_objectSpread({}, state.plan), {}, {
            digitalAbstractLimitReached: props.digitalAbstractLimitReached
          })
        });
      }
    case c.ERROR_UPDATED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          error: action.error
        });
      }
    case c.PLAN_UPDATE_FLAGGED:
    case c.PLAN_UPDATE_SYNCED:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: props.status
      });
    case c.PLAGIARISM_PLAN_UPDATE_SYNCED:
    case c.PLAGIARISM_PAYMENT_SYNCED:
      {
        var _state$plagiarismStat;
        var status = action.status,
          fileIdentity = action.fileIdentity;
        if (!status) return state;
        if (!Array.isArray(status) && status.paddlePending === false && !status.fileIdentity && !fileIdentity) {
          return _objectSpread(_objectSpread({}, state), {}, {
            plagiarismStatus: _objectSpread(_objectSpread({}, state.plagiarismStatus), {}, {
              documentStatuses: {}
            })
          });
        }
        var documentStatuses = normalizeDocumentStatuses(status, fileIdentity);
        return _objectSpread(_objectSpread({}, state), {}, {
          plagiarismStatus: _objectSpread(_objectSpread({}, state.plagiarismStatus), {}, {
            documentStatuses: _objectSpread(_objectSpread({}, (_state$plagiarismStat = state.plagiarismStatus) === null || _state$plagiarismStat === void 0 ? void 0 : _state$plagiarismStat.documentStatuses), documentStatuses)
          })
        });
      }
    case c.PLAGIARISM_DOCUMENT_ARCHIVED:
      return _objectSpread(_objectSpread({}, state), {}, {
        plagiarismStatus: _objectSpread(_objectSpread({}, state.plagiarismStatus), {}, {
          fileIdentity: state.plagiarismStatus.fileIdentity.filter(function (fid) {
            return fid !== action.id;
          })
        })
      });
    case c.START_SUBSCRIPTION_TODAY:
      return _objectSpread(_objectSpread({}, state), {}, {
        plans: _objectSpread(_objectSpread({}, state.plans), {}, {
          premium: _objectSpread(_objectSpread({}, state.plans.premium), {}, {
            paymentStatus: 'active'
          })
        })
      });

    // TODO: Move anything related to the user's specific plan into it's own object in curie state
    // so we can clear it out without needing this mess
    case c.CLEAR_RUBRIQ_PLAN:
      return _objectSpread(_objectSpread({}, state), {}, {
        plan: _objectSpread(_objectSpread({}, state.plan), {}, {
          planType: undefined,
          editsUsed: undefined,
          hasTranslation: undefined,
          subscriptionInterval: undefined,
          planPrice: undefined,
          startsAt: undefined,
          endsAt: undefined,
          status: undefined,
          availablePlanIdentity: undefined,
          preferredGroupCode: undefined
        })
      });
    case c.TRANSITION_MODAL_CLEARED:
      return _objectSpread(_objectSpread({}, state), {}, {
        acknowledgedNotifications: _objectSpread(_objectSpread({}, state.acknowledgedNotifications), {}, {
          curieLaunchNotified: true
        })
      });
    case c.CANCEL_RUBRIQ_PLAN:
      {
        var premium = state.plans.premium;
        var wasTrialing = premium.paymentStatus === 'trialing';
        return _objectSpread(_objectSpread({}, state), {}, {
          plans: _objectSpread(_objectSpread({}, state.plans), {}, {
            premium: wasTrialing ? _objectSpread(_objectSpread({}, premium), {}, {
              cancelState: 'trial'
            }) : _objectSpread(_objectSpread({}, premium), {}, {
              status: 'cancelled',
              cancelState: 'nontrial'
            })
          })
        });
      }
    case c.CRITERIA_WIZARD_SESSION_STARTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        abstractWriter: _objectSpread(_objectSpread({}, state.abstractWriter), {}, {
          steps: {},
          currentStep: '',
          criteriaResponses: {}
        }, props)
      });
    case c.CRITERIA_WIZARD_SESSION_LOADED:
    case c.CRITERIA_WIZARD_SESSION_SAVED:
      return _objectSpread(_objectSpread({}, state), {}, {
        abstractWriter: _objectSpread(_objectSpread({}, state.abstractWriter), props)
      });
    case c.ABSTRACT_SEARCH_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        abstractWriter: _objectSpread(_objectSpread({}, state.abstractWriter), {}, {
          searchBusy: true
        })
      });
    case c.ABSTRACT_SEARCH_COMPLETED:
      return _objectSpread(_objectSpread({}, state), {}, {
        abstractWriter: _objectSpread(_objectSpread({}, state.abstractWriter), {}, {
          searchBusy: false,
          abstracts: props.abstracts
        })
      });
    case c.TEMPLATE_RESPONSE_SAVED:
      return _objectSpread(_objectSpread({}, state), {}, {
        abstractWriter: _objectSpread(_objectSpread({}, state.abstractWriter), {}, {
          templateResponses: _objectSpread({}, props)
        })
      });
    case c.SESSION_SAVED:
      return _objectSpread(_objectSpread({}, state), {}, {
        abstractWriter: _objectSpread({}, props)
      });
    case c.PADDLE_INVOICES_LOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        paddleInvoices: {
          payments: action.payments
        }
      });
    case c.PADDLE_FAPIAO_CANCELLED:
      return _objectSpread(_objectSpread({}, state), {}, {
        paddleInvoices: _objectSpread(_objectSpread({}, state.paddleInvoices), {}, {
          payments: state.paddleInvoices.payments.map(function (payment) {
            if (payment.fapiao && payment.fapiao.identity === action.fapiaoIdentity) {
              return _objectSpread(_objectSpread({}, payment), {}, {
                fapiao: _objectSpread(_objectSpread({}, payment.fapiao), {}, {
                  status: 'cancellation-pending',
                  downloadUrl: action.fapiao.url
                })
              });
            }
            return payment;
          })
        })
      });
    case FETCH_PADDLE_PRICES_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        paddlePricing: _objectSpread(_objectSpread({}, state.paddlePricing), {}, {
          loading: true
        })
      });
    case FETCH_PADDLE_PRICES_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        paddlePricing: {
          prices: action.payload.prices,
          country: action.payload.country,
          currency: action.payload.currency,
          loading: false
        }
      });
    case FETCH_PADDLE_PRICES_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        paddlePricing: _objectSpread(_objectSpread({}, state.paddlePricing), {}, {
          loading: false
        })
      });
    default:
      return state;
  }
};